module.exports = __webpack_public_path__ + "static/media/PLANCHAP_MENU-normal.5ff354e5.png";